/* hearth-parent-cut.js — Session P2, 25 Sep 2026 (item 3 added in P3).
   Small additions to the hearth pages, kept out of hearth-parent.js the
   same way the sticky bar and postcode checker are (look separate from logic):

   1. TOTAL LINE. The breakdown above Add to Basket now ends in a bold Total,
      agreed in the Hearth Pair mockup (tab 1, item 3). hearth-parent.js sets
      the price under the title and THEN rebuilds #hp-lines in the same
      render, so the Total simply copies #hp-price. Runs on every hearth-parent
      page (riven, honed, brushed, black and grey limestone).

   2. CUT TO SIZE HAND-OFF. On pages where the "Not the size you need?" panel
      is switched on, its link carries the chosen thickness and grade across
      (?finish=…&thk=20mm|30mm&grade=Standard|Premium). Only values the Cut
      to Size page understands are passed.

   3. NO SIGNATURE WHERE CUT TO SIZE EXISTS (P3). On pages showing the hand-off
      panel (riven, honed, brushed) the Finish step is Slab Only / Deep Clean &
      Seal only — cutting is sold on the Cut to Size page (mockup tab 1,
      item 2). The Signature option is removed from #hp-fin; its hidden panel
      stays in the markup so hearth-parent.js runs unchanged. Limestone has no
      hand-off panel, so it keeps Signature. To bring Signature back on a
      slate page, switch off "Show 'Not the size you need?' panel" — or
      delete this block. */
(function () {
  var lines = document.getElementById('hp-lines');
  var price = document.getElementById('hp-price');
  var link = document.getElementById('hp-cut-link');
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('hp-config').textContent); } catch (e) { cfg = {}; }

  function dropSignature() {
    if (!link) return;
    var fin = document.getElementById('hp-fin');
    if (!fin) return;
    var sig = fin.querySelector('option[value="sig"]');
    if (!sig) return;
    var wasSig = fin.value === 'sig';
    fin.removeChild(sig);
    if (wasSig) {
      fin.value = 'none';
      fin.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function addTotal() {
    if (!lines || !price) return;
    if (!lines.querySelector('.hp__line') || lines.querySelector('.hp__line--total')) return;
    var row = document.createElement('div');
    row.className = 'hp__line hp__line--total';
    var a = document.createElement('span');
    a.textContent = lines.getAttribute('data-total-label') || 'Total';
    var b = document.createElement('span');
    b.textContent = price.textContent;
    row.appendChild(a);
    row.appendChild(b);
    lines.appendChild(row);
  }

  function optValue(i) {
    if (typeof i !== 'number' || i < 0) return '';
    var s = document.getElementById('hp-opt-' + i);
    return s ? String(s.value || '') : '';
  }

  function updateLink() {
    if (!link) return;
    var q = '?finish=' + encodeURIComponent(link.getAttribute('data-finish') || 'riven');
    var thk = optValue(cfg.idxThk);
    if (/^(20|30)mm$/.test(thk)) q += '&thk=' + thk;
    var grd = optValue(cfg.idxGrade);
    if (grd === 'Standard' || grd === 'Premium') q += '&grade=' + grd;
    link.setAttribute('href', (link.getAttribute('data-base') || '/products/slate-hearth-cut-to-size') + q);
  }

  function run() { addTotal(); updateLink(); }

  dropSignature();
  if (lines && window.MutationObserver) {
    new MutationObserver(run).observe(lines, { childList: true });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('hp__optselect')) updateLink();
  });
  run();
})();
